module.exports = __webpack_public_path__ + "static/media/1POLICY34.67331a51.jpg";